import { useScheduleSettings } from "routes/schedule/lib/useScheduleSettings"
import { useRef, useState } from "react"
import { Box, Button, Menu, Portal, Stack } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { RefreshScheduleSelector, TaskListRefresh } from "event-definitions"
import { Bound } from "lib/@components/binding/Bound"
import { Repeat } from "lib/@components/repeat"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { resolveScheduleViewModeLabel, resolveScheduleViewModes } from "routes/schedule/lib/right-bar-layout-presenters"
import { ScheduleViewModeMenuItem } from "./schedule-view-mode-menu-item"

export function ScheduleViewMode() {
    const [anchor, setAnchor] = useState(null)
    const [{ showDetail, onePage }, save] = useScheduleSettings()
    const { isAuthoringScheduleEditor = false } = useBoundContext()
    const ref = useRef()
    const modes = resolveScheduleViewModes({ isAuthoringScheduleEditor })
    return (
        <>
            <Stack
                className="view-mode"
                data-cy="schedule-view-mode-trigger"
                onClick={open}
                alignItems="center"
                component={Button}
                sx={{ cursor: "pointer", fontSize: "85%", lineHeight: 1, mt: 0.2, color: "text.primary" }}
                role="menu"
                direction="row"
                spacing={1}
            >
                <Box sx={{ fontWeight: "bold" }}>View:</Box>
                <Box sx={{ fontWeight: "normal" }} ref={ref}>
                    {modeName()}
                </Box>
                <Box sx={{ fontSize: 24, lineHeight: 0 }}>
                    <Iconify icon="mdi:arrow-down-drop" />
                </Box>
            </Stack>
            <Portal>
                <Menu sx={{ zIndex: 3000 }} onClose={close} open={Boolean(anchor)} anchorEl={anchor}>
                    <Bound
                        currentShowDetail={showDetail}
                        currentOnePage={resolveSelectedOnePage()}
                        onSelectMode={selectMode}
                    >
                        <Repeat list={modes} item={<ScheduleViewModeMenuItem />} />
                    </Bound>
                </Menu>
            </Portal>
        </>
    )

    function open() {
        setAnchor(ref.current)
    }

    function close() {
        setAnchor(null)
    }

    function selectMode(showDetail, onePage) {
        save({ showDetail, onePage })
        close()
        RefreshScheduleSelector.raiseOnce()
        TaskListRefresh.raise()
    }

    function modeName() {
        return resolveScheduleViewModeLabel({ isAuthoringScheduleEditor, onePage, showDetail })
    }

    function resolveSelectedOnePage() {
        return isAuthoringScheduleEditor ? false : onePage
    }
}
